"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChipArrayInput = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var icons_1 = __importDefault(require("../../../assets/icons"));
var Button_1 = require("../../atoms/Button/Button");
var TextField_1 = require("../../atoms/TextField/TextField");
var ChipArray_1 = require("../ChipArray/ChipArray");
var ChipArrayInput_logic_1 = require("./ChipArrayInput.logic");
var ChipArrayInput_static_1 = require("./ChipArrayInput.static");
/**
 * ChipArrayInput molecule
 *
 * {@link https://stories.data.bmw.cloud/?path=/docs/molecules-chiparrayinput--chip-array-input-bound Docs}
 * {@link https://github.com/bmw-cdh/cdh-data-portal-theme/tree/main/components/molecules/ChipArrayInput Source}
 */
var ChipArrayInput = function (_a) {
    var _b = _a.addText, addText = _b === void 0 ? ChipArrayInput_static_1.localText.add : _b, className = _a.className, _c = _a.disabled, disabled = _c === void 0 ? false : _c, disallowDuplicates = _a.disallowDuplicates, errorText = _a.errorText, helperText = _a.helperText, validate = _a.validate, label = _a.label, labelAdditionalInfo = _a.labelAdditionalInfo, onBlur = _a.onBlur, onFocus = _a.onFocus, placeholder = _a.placeholder, setValues = _a.setValues, values = _a.values;
    var _d = (0, ChipArrayInput_logic_1.useChipArrayInput)({
        disallowDuplicates: disallowDuplicates,
        errorText: errorText,
        validate: validate,
        setValues: setValues,
        values: values,
    }), adaptedErrorText = _d.adaptedErrorText, classes = _d.classes, currentInput = _d.currentInput, handleAdd = _d.handleAdd, onChange = _d.onChange, onDeleteChip = _d.onDeleteChip, onKeyDown = _d.onKeyDown, trimmedInput = _d.trimmedInput;
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: className }, { children: [(0, jsx_runtime_1.jsx)(TextField_1.TextField, { className: classes.textField, helperText: helperText, errorText: adaptedErrorText, label: label, value: currentInput, onChange: onChange, onKeyDown: onKeyDown, disabled: disabled, placeholder: placeholder, onFocus: onFocus, onBlur: onBlur, labelAdditionalInfo: labelAdditionalInfo, endAdornment: !!trimmedInput.length && ((0, jsx_runtime_1.jsx)(Button_1.Button, { title: addText, className: classes.addButton, variant: 'text', icon: icons_1.default.addCompact, onClick: handleAdd })) }), (0, jsx_runtime_1.jsx)(ChipArray_1.ChipArray, { labels: values, onDeleteChip: onDeleteChip, alwaysExpanded: true, disabled: disabled })] })));
};
exports.ChipArrayInput = ChipArrayInput;
